import "./App.css";
import React, { useState, useEffect } from "react";
import axios from "./Components/Axios";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import Tool from "./Components/Tool.js";
import { dummyPerChange, dummySeasonGrades } from "./Components/dummydata";
import { submit_hubspot_form } from "./Components/submit-hubspot.js";

//shape of state the drives the form
const initialFormValues = {
  firstname: "",
  lastname: "",
  company: "",
  email: "",
  latitude: "",
  longitude: "",
  covertype: "",
  clarity: "",
};

const initPosition = ["35.87552570061986", "-106.24811531819606"];

export default function App() {
  //state to initalize vales of the form
  const [spinner, setSpinner] = useState(false);
  const [formValues, setFormValues] = useState(initialFormValues);
  const [perChange, setPerChange] = useState();
  const [selectedPosition, setSelectedPosition] = useState(initPosition);
  const [grade, setGrade] = useState(0);
  const [seasonGrades, setSeasonGrades] = useState("");
  let navigate = useNavigate();

  const updateForm = (inputName, inputValue) => {
    setFormValues({ ...formValues, [inputName]: inputValue });
  };

  const updateLocation = (latlong) => {
    setSelectedPosition(latlong);
    setFormValues({
      ...formValues,
      latitude: latlong[0].toString(),
      longitude: latlong[1].toString(),
    });
  };

  const submitForm = () => {
    const newCustomer = {
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      company: formValues.company,
      email: formValues.email,
      latitude: formValues.latitude,
      longitude: formValues.longitude,
      crop: formValues.crop,
      covertype: formValues.covertype,
      clarity: formValues.clarity,
    };

    setSpinner(true);
    submit_hubspot_form(
      formValues.email,
      formValues.firstname,
      formValues.lastname,
      formValues.company
    );
    axios
      .post("/userinput", newCustomer)
      .then((resp) => {
        setGrade(resp.data[2][4]);
        setPerChange(resp.data[1]);
        setSeasonGrades(resp.data[2]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  const isDisabled = () => {
    if (
      formValues.firstname.length >= 1 &&
      formValues.lastname.length >= 1 &&
      formValues.company.length >= 1 &&
      formValues.email.length >= 1 &&
      formValues.covertype.length >= 1 &&
      formValues.clarity.length >= 1 &&
      formValues.latitude.length >= 1 &&
      formValues.longitude.length >= 1
    ) {
      return false;
    } else return true;
  };

  return (
    <div>
      <Tool
        submitForm={submitForm}
        updateForm={updateForm}
        isDisabled={isDisabled}
        spinner={spinner}
        perChange={perChange}
        formValues={formValues}
        grade={grade}
        selectedPosition={selectedPosition}
        updateLocation={updateLocation}
        seasonGrades={seasonGrades}
      />
    </div>
  );
}
